<template>
  <div class="jumbotron">
    <div class="row">
      <h4>Profile Preferences</h4>
    </div>
    <div class="row">
      <div class="col-md-8 text-right">
        <p class="no-margin-bottom">Hide Address and Display Service Area Only</p>
      </div>
      <div class="col my-auto">
        <p class="d-inline">No</p>
        <label class="switch">
          <input v-model="hideAddress" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p class="d-inline">Yes</p>
      </div>
    </div>
    <!--<div class="row">
      <div class="col-md-8 text-right">
        <p class="no-margin-bottom">Allow Customers to send Texts</p>
      </div>
      <div class="col my-auto">
        <p class="d-inline">No</p>
        <label class="switch">
          <input v-model="allowSendTexts" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p class="d-inline">Yes</p>
      </div>
    </div>-->
    <div class="row">
      <div class="col-md-8 text-right">
        <p class="no-margin-bottom">Enable Customers to Request a Quote</p>
      </div>
      <div class="col my-auto">
        <p class="d-inline">No</p>
        <label class="switch">
          <input v-model="enableQuoteRequest" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p class="d-inline">Yes</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 text-right">
        <p class="no-margin-bottom">Hide Years in Service</p>
      </div>
      <div class="col my-auto">
        <p class="d-inline">No</p>
        <label class="switch">
          <input v-model="hideYears" value="true" type="checkbox">
          <span class="slider round"></span>
        </label>
        <p class="d-inline">Yes</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 offset-lg-3">
        <button v-if="complete" v-on:click="save"
                class='btn btn-primary'>Save</button>
        <button v-else v-on:click="save" class="btn btn-primary">Save & Continue</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <b-alert variant="success"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
          Data Saved
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import router from '../../../../../router/index.js'

export default {
  created () {
    this.complete = this.profileIsComplete.profileComplete
  },
  data () {
    return {
      showDismissibleAlert: false
    }
  },
  methods: {
    async save () {
      this.syncData()
      this.showDismissibleAlert = true
      if (!this.complete) {
        router.replace('/profile/business/contacts')
      }
    },
    ...mapActions('business', [
      'syncData'
    ]),
    ...mapMutations('business', [
      'updateHideAddress',
      'updateAllowSendTexts',
      'updateEnableQuoteRequest',
      'updateHideYears'
    ])
  },
  computed: {
    ...mapGetters('business', [
      'getHideAddress',
      'getAllowSendTexts',
      'getEnableQuoteRequest',
      'getHideYears',
      'profileIsComplete'
    ]),
    hideAddress: {
      get () {
        return this.getHideAddress
      },
      set (value) {
        this.updateHideAddress(value)
      }
    },
    allowSendTexts: {
      get () {
        return this.getAllowSendTexts
      },
      set (value) {
        this.updateAllowSendTexts(value)
      }
    },
    enableQuoteRequest: {
      get () {
        return this.getEnableQuoteRequest
      },
      set (value) {
        this.updateEnableQuoteRequest(value)
      }
    },
    hideYears: {
      get () {
        return this.getHideYears
      },
      set (value) {
        this.updateHideYears(value)
      }
    }
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.row {
  padding-bottom: 1rem;
}

.btn-secondary {
  width: 100%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #FEEDAA;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/details/details/Preferences.vue